import React, { useEffect, useState, useRef } from 'react';
import { ZapIcon, ShieldCheckIcon, UserIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
export function WhatIsSCB300() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.2
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  const items = en ? [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-244" />,
    label: 'Electric drive',
    text: 'A powerful motor with controlled climbing delivers smooth, stable operation on stairs without sudden movements.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-245" />,
    label: 'Control & safety',
    text: 'Integrated electric brake and a solid frame keep the load under control throughout the entire ascent and descent.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-246" />,
    label: 'Single operator',
    text: 'Designed so one person can safely move heavy cargo without additional workforce.'
  }] : [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-247" />,
    label: 'Električni pogon',
    text: 'Sistem sa snažnim motorom i kontrolisanim penjanjem omogućava stabilan rad uz stepenice bez naglih pokreta.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-248" />,
    label: 'Kontrola i bezbednost',
    text: 'Integrisana električna kočnica i stabilna konstrukcija drže teret pod kontrolom tokom celog uspona i silaska.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-249" />,
    label: 'Jedan operater',
    text: 'Dizajnirano da jedna osoba bezbedno premešta teške terete bez dodatne radne snage.'
  }];
  const footer = en ? 'D-TECH offers a range of electric stair-climbing machines and cargo transport solutions, designed for professional use in construction, logistics, warehouses and delivery services. Combining power, stability and simple operation in compact systems.' : 'D-TECH nudi električne mašine za transport tereta uz stepenice i industrijska kolica, namenjene profesionalnoj upotrebi u građevini, logistici, skladištima i uslugama dostave. Snaga, stabilnost i jednostavno rukovanje u kompaktnim sistemima.';
  return <section className="py-14 md:py-20 bg-dark-surface border-b border-dark-border" data-id="element-250">
      <div ref={ref} className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <h2 className={`text-2xl md:text-3xl font-black text-white mb-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} data-id="element-252">
          {en ? 'How does ' : 'Kako funkcioniše '}
          <span className="text-brand-yellow" data-id="element-253">
            {en ? 'D-TECH?' : 'D-TECH?'}
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-254">
          {items.map((item, i) => <div key={i} className="flex flex-col gap-3 p-5 bg-dark-bg border border-dark-border rounded-industrial" style={{
          transitionProperty: 'opacity, transform',
          transitionDuration: '700ms',
          transitionDelay: `${i * 150}ms`,
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)'
        }} data-id="element-255">
              <div className="flex items-center gap-3" data-id="element-256">
                {item.icon}
                <span className="text-brand-yellow font-bold text-base" data-id="element-257">
                  {item.label}
                </span>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-258">
                {item.text}
              </p>
            </div>)}
        </div>

        <p className={`mt-8 text-gray-400 text-sm leading-relaxed transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-259">
          {footer}
        </p>
      </div>
    </section>;
}